export default __webpack_public_path__ + "static/media/glass_tube.77b1868a.svg";